import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FormIdentificator, Offer, OfferSummary } from '@onedv-flexgate/shared'
import { environment } from '../../environments/environment'

@Injectable({ providedIn: 'root' })
export class OfferService {
  private readonly http = inject(HttpClient)

  getOffers() {
    return this.http.get<OfferSummary[]>(`${environment.apiUrl}/offers`)
  }

  getOffer(contractNumber: string) {
    return this.http.get<Offer>(`${environment.apiUrl}/offers/${contractNumber}`)
  }

  patchOffer(contractNumber: string, formIdentificator: FormIdentificator, data: unknown) {
    return this.http.patch<Offer>(`${environment.apiUrl}/offers/${contractNumber}`, {
      contractNumber,
      formIdentificator,
      data,
    })
  }

  sendToSharepoint(contractNumber: string) {
    return this.http.post<{ message: string }>(`${environment.apiUrl}/offers/${contractNumber}/sharepoint`, {})
  }
}
